module.exports = __webpack_public_path__ + "static/media/information.c2f61438.svg";